import React from 'react';
import styles from './index.less';

const WarnContent = ({ type = 'warn', title, text }) => (
  <>
    <div className={styles.title}>
      <div className={styles.title_icon}>
        {type === 'warn' ? '!' : '?'}
      </div>
      <span className={styles.title_text}>{title}</span>
    </div>
    {text && (
      <div className={styles.content}>{text}</div>
    )}
  </>
);

export default WarnContent;
